module.exports = __webpack_public_path__ + "media/images/scan-screen-02196da0ada9f8f6efc697be7eafd931.png";